import styled from '@emotion/styled';
import { Modal, Button, ButtonProps } from '@mantine/core';
import { useState } from 'react';
import { MenuItem, secondaryMenu } from '../menus';
import { TosModal } from './tos';

const HeaderButtonWrapper = styled.div`
    .mantine-Button-root {
        font-family: "Work Sans", sans-serif;
    }
`;

function ContactButtonComponent(props: ButtonProps & { icon?: string, onClick?: any, children?: any }) {
    return (
        <Button size='xs'
            variant={props.variant || 'light'}
            onClick={props.onClick}>
            {props.icon && <i className={'fa fa-' + props.icon} />}
            {props.children && <span>
                {props.children}
            </span>}
        </Button>
    )
}

const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 0.5rem;
`;

const ContactLink = styled.a`
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1rem 1.5rem;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 0.5rem;
    color: white;
    text-decoration: none;
    font-family: "Work Sans", sans-serif;
    font-size: 1.1rem;
    transition: all 0.2s ease;
    
    &:hover {
        background: rgba(255, 0, 0, 0.2);
        border-color: rgba(255, 0, 0, 0.3);
        transform: translateX(4px);
    }
    
    i {
        font-size: 1.5rem;
        width: 2rem;
        text-align: center;
    }
    
    span {
        flex-grow: 1;
    }
    
    &::after {
        content: '→';
        opacity: 0.5;
    }
`;

const ModalTitle = styled.h3`
    margin: 0;
    font-family: "Work Sans", sans-serif;
    font-size: 1.5rem;
    font-weight: 600;
    color: white;
    text-align: center;
    margin-bottom: 0.5rem;
`;

export default function ContactButton() {
    const [opened, setOpened] = useState(false);
    const [tosOpened, setTosOpened] = useState(false);

    const handleItemClick = (item: MenuItem, e: React.MouseEvent) => {
        if (item.link.startsWith('internal:')) {
            e.preventDefault();
            const internalRoute = item.link.split(':')[1];
            if (internalRoute === 'tos') {
                setTosOpened(true);
            }
        }
    };

    return (
        <>
            <HeaderButtonWrapper>
                <ContactButtonComponent
                    icon="envelope"
                    onClick={() => setOpened(true)}
                    aria-label="Contact us"
                >
                    <span>Contact</span>
                </ContactButtonComponent>
            </HeaderButtonWrapper>
            
            <Modal
                opened={opened}
                onClose={() => setOpened(false)}
                title={<ModalTitle>Contact Us</ModalTitle>}
                centered
                size="sm"
                styles={{
                    modal: {
                        backgroundColor: '#303038',
                        border: '1px solid rgba(255, 255, 255, 0.1)',
                    },
                    header: {
                        backgroundColor: 'transparent',
                        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                    },
                    title: {
                        width: '100%',
                    },
                    close: {
                        color: 'white',
                        '&:hover': {
                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                        },
                    },
                }}
            >
                <ModalContent>
                    {secondaryMenu.map((item: MenuItem) => (
                        <ContactLink
                            key={item.link}
                            href={item.link.startsWith('internal:') ? '#' : item.link}
                            target={item.link.startsWith('internal:') ? '_self' : '_blank'}
                            rel="noopener noreferrer"
                            onClick={(e) => handleItemClick(item, e)}
                        >
                            {item.icon && <i className={`fa fa-${item.icon}`} />}
                            <span>{item.label}</span>
                        </ContactLink>
                    ))}
                </ModalContent>
            </Modal>

            <TosModal opened={tosOpened} onClose={() => setTosOpened(false)} />
        </>
    );
}
